var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M4.5,37.2h36.1c0.3,0,0.5-0.3,0.5-0.6v-2.8c0-0.3-0.2-0.6-0.5-0.6h-1.5V11.7h1.5c0.3,0,0.5-0.3,0.5-0.6V8.3 c0-0.4-0.2-0.6-0.5-0.6H4.5C4.2,7.7,4,7.9,3.9,8.1c0,0.1,0,0.2,0,0.2V11c0,0.3,0.3,0.6,0.6,0.6h1.4v21.6H4.5 c-0.3,0-0.6,0.3-0.6,0.6v2.8C3.9,37,4.2,37.2,4.5,37.2z M5,10.5V8.8h3.6h27.8H40v1.6H5z M7.1,11.7H38v21.6h-3.8V20.5 c0-0.3-0.3-0.6-0.6-0.6H11.4c-0.3,0-0.5,0.3-0.5,0.6v12.8H7.1V11.7z M29,29.3h2.5v3.9H29V29.3z M32.6,28.8c0-0.3-0.3-0.5-0.6-0.5 h-3.6c-0.3,0-0.5,0.2-0.5,0.5v4.5h-1.6v-2.6c0-0.3-0.3-0.6-0.6-0.6h-3.3v-4.2V25c0-0.3-0.3-0.5-0.6-0.5h-3.3v-2.2 c0-0.3-0.2-0.5-0.5-0.5h-4.2c-0.3,0-0.5,0.2-0.5,0.5v10.9H12V21h21.1v12.2h-0.5V28.8z M21.2,27.8h-2.7v-2.1h2.7V27.8z M14.4,27h3 v2.8h-3V27z M17.4,25.9h-3V23h3V25.9z M14.4,30.8h3v2.4h-3V30.8z M18.5,28.8h2.7v4.4h-2.7V28.8z M22.4,31.2h2.8v2.1h-2.8V31.2z  M5,34.3h35v1.8H5V34.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M33.1,21H12v12.2h1.3V22.3c0-0.3,0.2-0.5,0.5-0.5H18c0.3,0,0.5,0.2,0.5,0.5v2.2h3.3c0.3,0,0.6,0.2,0.6,0.5 v0.8V30h3.3c0.3,0,0.6,0.3,0.6,0.6v2.6h1.6v-4.5c0-0.3,0.2-0.5,0.5-0.5H32c0.3,0,0.6,0.2,0.6,0.5v4.5h0.5V21z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 29,
  y: 29.3,
  fill: "#C9C9C9",
  width: 2.5,
  height: 3.9
}), /*#__PURE__*/React.createElement("rect", {
  x: 22.4,
  y: 31.2,
  fill: "#C9C9C9",
  width: 2.8,
  height: 2.1
}), /*#__PURE__*/React.createElement("rect", {
  x: 18.5,
  y: 25.7,
  fill: "#C9C9C9",
  width: 2.7,
  height: 2.1
}), /*#__PURE__*/React.createElement("rect", {
  x: 18.5,
  y: 28.8,
  fill: "#C9C9C9",
  width: 2.7,
  height: 4.4
}), /*#__PURE__*/React.createElement("rect", {
  x: 14.4,
  y: 27,
  fill: "#C9C9C9",
  width: 3,
  height: 2.8
}), /*#__PURE__*/React.createElement("rect", {
  x: 14.4,
  y: 30.8,
  fill: "#C9C9C9",
  width: 3,
  height: 2.4
}), /*#__PURE__*/React.createElement("rect", {
  x: 14.4,
  y: 23,
  fill: "#C9C9C9",
  width: 3,
  height: 2.9
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M7.1,33.2h3.8V20.5c0-0.3,0.2-0.6,0.5-0.6h22.2c0.3,0,0.6,0.3,0.6,0.6v12.8H38V11.7H7.1V33.2z M30.8,17.3 H14.2c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.5,0.6-0.5h16.6c0.4,0,0.6,0.2,0.6,0.5C31.4,17.1,31.1,17.3,30.8,17.3z M14.2,13.8h16.6 c0.4,0,0.6,0.2,0.6,0.5c0,0.3-0.3,0.6-0.6,0.6H14.2c-0.3,0-0.6-0.3-0.6-0.6C13.6,14.1,13.9,13.8,14.2,13.8z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 5,
  y: 34.3,
  fill: "#A1A1A1",
  width: 35,
  height: 1.8
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#A1A1A1",
  points: "40,10.5 40,8.8 36.4,8.8 8.6,8.8 5,8.8 5,10.5  "
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M30.8,16.2H14.2c-0.3,0-0.6,0.2-0.6,0.5c0,0.3,0.3,0.6,0.6,0.6h16.6c0.3,0,0.6-0.3,0.6-0.6 C31.4,16.5,31.2,16.2,30.8,16.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M14.2,15h16.6c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.2-0.5-0.6-0.5H14.2c-0.3,0-0.6,0.2-0.6,0.5 C13.6,14.7,13.9,15,14.2,15z"
}));

function SvgWarehouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.474bbadffb16bdb3b0711c2cc98648f1.svg";
export { ForwardRef as ReactComponent };